/**
 * Paneles sugeridos: un bloque que nace ya armado para una pregunta concreta (tanda «Feedback de
 * Hesta», momento 2). Se ofrecen en el mismo desplegable de «Agregar», debajo de los cinco tipos.
 *
 * «Plataforma vs. GA4 por campaña» (contrato §4): la tabla donde el reparto de GA4 por campaña se
 * ve. Campaña y nada más como dimensión — con Plataforma, Cuenta o Estado, GA4 cae en filas aparte
 * (`ga4Split.js`) — y las métricas de la plataforma al lado de las de GA4.
 *
 * Las columnas se recortan a lo que la FUENTE del informe admite (`FIELDS_BY_DATA_SOURCE_TYPE`):
 * «ROAS (GA4)» (`GA4__ROAS`) está en el catálogo pero hoy no se ofrece en ninguna fuente, y el
 * nodo no tiene su fórmula. Con el recorte, el preset no pide una columna que el render
 * rechazaría, y la suma sola el día que el catálogo la ofrezca.
 */
import {FIELD_KINDS, PANEL_TYPES, newUid} from './informeModel';

export const PRESET_PLATFORM_VS_GA4 = Object.freeze({
    id: 'platform_vs_ga4',
    nameKey: 'informes.presets.platform_vs_ga4',
    name: 'Plataforma vs. GA4 por campaña',
    descKey: 'informes.presets.platform_vs_ga4_desc',
    desc: 'Compara lo que reporta cada plataforma con lo que mide GA4, campaña por campaña.',
    dimensions: Object.freeze(['Campana']),
    metrics: Object.freeze([
        'Costo', 'Valor_de_compra', 'GA4__Ingresos_por_compras', 'ROAS', 'GA4__ROAS',
        'GA4__Transacciones_de_comercio_electrónico',
    ]),
    // Sin estas no hay comparación que mostrar: el preset no se ofrece.
    required: Object.freeze(['Campana', 'GA4__Ingresos_por_compras']),
});

function offeredBySource(fieldsData, sourceType) {
    const bySource = fieldsData && fieldsData.FIELDS_BY_DATA_SOURCE_TYPE;
    return new Set((bySource && bySource[sourceType]) || []);
}

/** Los presets que se ofrecen: sólo con GA4 en el cliente y si la fuente tiene lo indispensable. */
export function availablePresets({clientHasGa4, fieldsData, sourceType}) {
    if (!clientHasGa4) return [];
    const offered = offeredBySource(fieldsData, sourceType);
    return [PRESET_PLATFORM_VS_GA4].filter((preset) => preset.required.every((id) => offered.has(id)));
}

/**
 * El panel y los campos que necesita en la paleta (`[{name, kind}]`), recortados a la fuente. El
 * título va escrito: es el que lee el cliente en el portal.
 */
export function presetPanel(preset, {fieldsData, sourceType, title}) {
    const offered = offeredBySource(fieldsData, sourceType);
    const dimensions = preset.dimensions.filter((id) => offered.has(id));
    const metrics = preset.metrics.filter((id) => offered.has(id));
    const uid = newUid();
    return {
        panel: {uid, id: uid, type: PANEL_TYPES.TABLE, title: title || '', dimensions, metrics},
        fields: [
            ...dimensions.map((name) => ({name, kind: FIELD_KINDS.DIMENSION})),
            ...metrics.map((name) => ({name, kind: FIELD_KINDS.METRIC})),
        ],
    };
}
